import "./App.scss";

import React, { Component } from "react";
import { createStore } from "redux";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import config from "./config";
// import { logger } from "./middleware";
import rootReducers from "./reducers";
import "@hz/fix-ios-12-keyboard-bug";
// 低版本react-scripts在build时不支持es6/7语法，先注释掉BI/APM接入，从index.html引入脚本
import getEnv from "@hz/env";
import beidou from "./utils/beidou";
// import { init as initApm } from "@elastic/apm-rum";
// import { init } from "@hz/beidou-js-sdk";

/**
 * 路由
 */

import routerMap from "./router/router-map";
/**
 * 唯一的 Store
 */
const store = createStore(
	rootReducers
	// applyMiddleware(
	//     logger,//日志
	// )
);

const { version } = require("../package.json");

class App extends Component {
	constructor() {
		super();
		global.config = config; //全局
		if (typeof window !== "undefined") {
			beidou.init();
			// const beidouInstance = window.BeidouInject.init({
			// 	app_id: "73043a72f3e34f70a7b44da42640dd56",
			// 	app_version: version,
			// 	// 如果有使用到next.js的内置链接，该选项需要开启用来追踪next.js的单页面应用跳转
			// 	is_track_single_page: true,
			// 	// 下面的一般情况请不要开启，会记录所有的用户行为，上行流量会很大
			// 	heatmap: {
			// 		//是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
			// 		clickmap: "default",
			// 		//是否开启触达注意力图，默认 not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启
			// 		scroll_notice_map: "default",
			// 	},
			// });
			// window.beidouInstance = beidouInstance;
			// beidouInstance.quick("autoTrack");

			const env = getEnv();
			const APM_SERVER_URL =
				env === "production"
					? "https://apm-collect.hzins.net"
					: env === "preview"
					? "https://apm-collect-pre.hzins.net/"
					: "https://apm-collect-test.hzins.net";
			// 开发环境禁用APM，避免上报过多无效数据
			if (env && env !== "development") {
				// 接入APM
				let parts = window.location.pathname.split("/");
				let pageName = window.location.pathname;
				if (parts.length > 0) {
					pageName = parts[1];
				}
				window.elasticApm.init({
					serviceName: "portal_static_passport",
					serverUrl: APM_SERVER_URL,
					serviceVersion: version,
					// 根据页面路由做聚合分类
					pageLoadTransactionName: pageName,
					// 使用公司的环境配置，不能直接读process.env，会在编译阶段处理替换掉
					environment: env,
					// distributedTracingOrigins: ['https://mm.huize.com'],
					ignoreTransactions: ["POST https://arms-retcode.aliyuncs.com/r.png"],
					crossOrigin: "anonymous",
				});
			}
		}
	}

	render() {
		return (
			<Provider store={store}>
				<Router path="/">
					<div className="App">
						<Switch>
							{routerMap.map((route, index) => (
								<Route
									key={index}
									path={route.path}
									exact={route.exact || true}
									component={route.main}
								/>
							))}
						</Switch>
					</div>
				</Router>
			</Provider>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js